// LoansListScreenDesktop

import LoanDashboardIndexScreen from "@/screens/loans/LoanDashboardIndexScreen"

export default function LoansListScreenDesktop() {
  return <LoanDashboardIndexScreen />
}
